import React from "react";
import { ArrowButton } from "../../components/arrow-button";
import { PhotoColumn } from "../../components/photo-column";
import TekbirlenmeMerasimi from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-kiyafetlerinin-tekbirlenmesi.jpg';
import Sema1 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-01.jpg';
import Sema2 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-02.jpg';
import Sema3 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-03.jpg';
import Sema4 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-04.jpg';
import Sema5 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-05.jpg';
import Sema6 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-06.jpg';
import Sema7 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-07.jpg';
import Sema8 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-08.jpg';
import Sema9 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-09.jpg';
import Sema10 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-10.jpg';
import Sema11 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-11.jpg';
import Sema12 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-12.jpg';
import Sema13 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-13.jpg';
import Sema14 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-14.jpg';
import Sema15 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-15.jpg';
import Sema16 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-16.jpg';
import Sema17 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-17.jpg';
import Sema18 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-18.jpg';
import Sema19 from '../../assets/photos/sema-kiyafetleri-tekbirlenmesi/sema-tekbirleme-19.jpg';

import "./sema.scss";

const photoData = [
    { imageSource: TekbirlenmeMerasimi, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema6, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema1, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema2, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema3, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema4, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema5, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema7, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema8, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema9, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema10, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema11, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema12, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema13, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema14, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema15, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema16, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema17, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema18, imageTitle: "", figcaptionFirstTitle: "" },
    { imageSource: Sema19, imageTitle: "", figcaptionFirstTitle: "" }
];
interface SemaTekbirlenmeMerasimiProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}
interface SemaTekbirlenmeMerasimiState {
    Change: boolean;
}



class SemaTekbirlenmeMerasimi extends React.Component<SemaTekbirlenmeMerasimiProps, SemaTekbirlenmeMerasimiState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }

    PhotoGallery = () => {
        return (
            <div>
                {photoData.map((photo, index) => (
                    <PhotoColumn
                        key={index}
                        imageSource={photo.imageSource}
                        imageTitle={photo.imageTitle}
                        figcaptionFirstTitle={photo.figcaptionFirstTitle}
                    />
                ))}
            </div>
        );
    };

    render() {
        return (
            <div style={{ display: this.props.isVisible ? "block" : "none" }}>
                <article>
                    <ArrowButton onClick={this.props.comeBackSemaSection} />
                    <h3 className="title">SEMA KIYAFETLERİNİN TEKBİRLENME MERASİMİ</h3>
                    {this.PhotoGallery()}
                </article>
            </div>
        );
    }
}

export default SemaTekbirlenmeMerasimi;